import store from 'store';
import sellerStore from 'store/indexSeller';
import getApiAuthToken from 'api/getApiAuthToken';
import {isCurrentAppSeller, isCurrentAppDefault} from 'utils/appTypeState';

export default function getRequestHeaders () {
  const headers = {};
  headers['X-API-Token'] = getApiAuthToken();

  if (isCurrentAppSeller() && sellerStore.getters['sellerCommon/sellerAccountId']) {
    headers['X-API-Account'] = sellerStore.getters['sellerCommon/sellerAccountId'];
  } else if (isCurrentAppDefault() && store.getters['accounts/currentAccount']) {
    headers['X-API-Account'] = store.getters['accounts/currentAccount'].id;
  }

  return headers;
}
